export default __webpack_public_path__ + "static/media/graph.7caaaca0.png";